module.exports = __webpack_public_path__ + "img/KSC03365.0605d412.jpg";